import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Form from "../components/Form.js";
import Input from "../components/input.js";
import Button from "../components/Button.js";
import { getApiBaseUrl } from "../utils/apiConfig";
import "./AdminRegister.css";

export default function AdminRegister() {
  const nav = useNavigate();
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    if (!username || !email || !password) {
      Swal.fire("Missing fields", "Please fill all fields.", "warning");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email.trim())) {
      Swal.fire("Invalid Email", "Please enter a valid email address.", "warning");
      return;
    }

    if (password.length < 8 || !/[A-Z]/.test(password) || !/[0-9]/.test(password)) {
      Swal.fire(
        "Weak Password",
        "Password must be at least 8 characters long and contain at least one uppercase letter and one number.",
        "warning"
      );
      return;
    }

    try {
      setBusy(true);
      const API = getApiBaseUrl();
      const res = await fetch(`${API}/admin/register-init`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, email, password }),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data?.message || "Failed to start registration.");
      }

      // Save regId for the OTP page
      localStorage.setItem("adminRegId", data.regId);

      await Swal.fire({
        title: "OTP Sent",
        text: "A 6-digit OTP has been sent to the company email (soloway.lk@gmail.com). Please get it and continue.",
        icon: "success",
        confirmButtonText: "Enter OTP",
        customClass: {
          confirmButton: 'custom-swal-confirm'
        },
        buttonsStyling: false,
      });

      nav("/adminregisterotp");
    } catch (err) {
      Swal.fire({
        title: "Error",
        text: err.message,
        icon: "error",
        confirmButtonText: "Try Again",
        customClass: {
          confirmButton: 'custom-swal-cancel'
        },
        buttonsStyling: false,
      });
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="adminregister-container">
      <main className="register-main">
        <Form title="Admin Registration" subtitle="Register a new admin account" onSubmit={onSubmit}>
          <Input
            label="Username"
            value={username}
            onChange={e => setUsername(e.target.value)}
            placeholder="Enter Username (admin)"
          />
          <Input
            label="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="Enter Email (admin@gmail.com)"
          />
          <Input
            label="Password"
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            placeholder="••••••••"
          />

          <Button type="submit" className="btn btn-primary" disabled={busy}>
            {busy ? "Processing..." : "Sign Up"}
          </Button>

          <div className="back-to-login">
            <span>Already have an account?</span>
            <button type="button" className="link-btn" onClick={() => nav("/adminlogin")}>
              Login
            </button>
          </div>
        </Form>
      </main>
    </div>
  );
}
